var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgress({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9444 13.2923C15.9444 14.7604 14.7604 15.9444 13.2923 15.9444H10.7076C9.23962 15.9444 8.05554 14.7604 8.05554 13.2923V10.7076C8.05554 9.23962 9.23962 8.05554 10.7076 8.05554H13.2923C14.7604 8.05554 15.9444 9.23962 15.9444 10.7076V13.2923Z",
    fill: "#0A49A5",
    stroke: "#0A49A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C17.53 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12",
    stroke: "#0A49A5",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/Progress.dc5ac8cbdf3fe5ebbe4c667e5a8f69af.svg";
export { ForwardRef as ReactComponent };